import React from "react";

const BASE = import.meta.env.BASE_URL;

function Side({ name, card, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={`${BASE}img/winner.png`} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4>{" "}
          <div className="casino-result-cards-item">
            <img src={`${BASE}img/cards/${card}.png`} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for 1 Day Dragon Tiger (dt6 / pdt6 / tdt6 / vdt6):
 * Dragon = card[0], Tiger = card[1]; trophy before the winner's card;
 * rdesc "winner#pair#odd-even#color#suit" → Winner / Pair / Odd/Even / Color / Suit.
 */
export default function Dt6ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const rows = [
    ["Winner", desc[0]],
    ["Pair", desc[1]],
    ["Odd/Even", desc[2]],
    ["Color", desc[3]],
    ["Suit", desc[4]],
  ];

  return (
    <div className="row row5">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <Side name="Dragon" card={cards[0]} isWinner={win === "1"} />{" "}
            <div className="casino-result-content-diveder" />{" "}
            <Side name="Tiger" card={cards[1]} isWinner={win === "2"} />
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {rows.map(([label, value], i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{value}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
